<template>
  <div>
    <div v-if="'AvuiTrensArriben' == tmpl">
      <Table :data="data" :urlsData="urlsData" rootData="trensquearriben" />
    </div>
    <div v-if="'AvuiTrensSurten' == tmpl">
      <Table :data="data" :urlsData="urlsData" reverse="true" rootData="trensquesurten"/>
    </div>
    <div v-if="'AvuiFanEscala' == tmpl">
      <Callport :data="data" />
    </div>
    <div v-if="'AvuiFanEscalaVaixells' == tmpl">
      <Summary :data="data" />
    </div>  
    <div v-if="'Reserves' == tmpl">
      <Reserves :data="data[0].vars" />
    </div> 
    <div v-if="'Tempsacces' == tmpl">
      <Tempsacces :data="data[0].vars" />
    </div> 
    <div v-if="'MeteoEstatActualHora' == tmpl">
      <Meteo :data="data[0].vars" />
    </div>
    <div v-if="'EstatActualMar' == tmpl">
      <Sea :data="data[0].vars" />
    </div>
    <div v-if="'VentBocanes' == tmpl">
      <Windbocanes :data="data[0].vars" />
    </div>
    <div v-if="'PortServeiMaritim' == tmpl">
      <MaritimContainers :data="data[0].vars" />
    </div>
    <div v-if="'AnualResum' == tmpl">
      <AnualReport :data="data[0].vars" />
    </div>
    
  </div>
</template>

<script>
import Table from './Table'
import Callport from './Callport'
import Summary from './Summary.vue'
import Reserves from './Reserves.vue'
import Tempsacces from './Tempsacces.vue'
import Meteo from './Meteo.vue'
import Sea from './Sea.vue'
import Windbocanes from './Windbocanes.vue'
import MaritimContainers from './MaritimContainers.vue'
import AnualReport from './AnualReport.vue'
export default {
  components: { Table, Callport, Summary, Reserves, Tempsacces, Meteo, Sea, Windbocanes, MaritimContainers, AnualReport },
  name: 'Layout',
  props: {
    data: Array,
    urlsData: Array,
    tmpl: String
  }
}
</script>
